import modules from './modules/index'

export default [
    {
        path: 'manage',
        component: () => import(/*webpackChunkName: 'manage'*/ '@views/layout/index'),
        children: [
            modules,
        ]
    },
]
